const ropeDescription = `Верёвка очень полезна для лазания, но Вы также можете использовать ее для расставления ловушек, переправы через пропасть или связывания заключенных.

У верёвки 2 хита, и её можно порвать проверкой Силы СЛ 17`

module.exports = ropeDescription
